import { createCountdownTimer } from "../../../timing";
import { callback, isPlainObject, withProperties } from "../../../utils";

function withCountdownTimer($context, options) {
  if (!(isPlainObject($context) && Object.isExtensible($context))) {
    throw new Error('Cannot setup countdown timer without appropriate context object.');
  }

  let {
    duration,
    onClear,
    onContinue,
    onExtend,
    onFinish,
    onHalt,
    onStart,
    onTick
  } = isPlainObject(options) ? options : {};

  onClear = callback(onClear);
  onContinue = callback(onContinue);
  onExtend = callback(onExtend);
  onFinish = callback(onFinish);
  onHalt = callback(onHalt);
  onStart = callback(onStart);
  onTick = callback(onTick);

  return withProperties($context, {
    $timer: createCountdownTimer({
      duration,
      onClear,
      onContinue,
      onExtend,
      onFinish,
      onHalt,
      onStart,
      onTick
    })
  });
}

export default withCountdownTimer;
